export enum RecordState {
    None,
    Win,
    Lose,
    Push,
    BJ,
    BUSH,
}
